// Rails UJS
import "./turbolinks";
// import Turbolinks from "turbolinks";
import "./import-jquery";
import {} from "jquery-ujs";
import "jquery-ui-dist/jquery-ui.js";
//
// Turbolinks.start();
//
import "./plugins";
import "./coucou";
import "./application";
import "./react";

// ------------------------------
// Cloudinary
// ------------------------------
//= require jquery.iframe-transport
//= require jquery.fileupload
//= require cloudinary/jquery.cloudinary
// ------------------------------
// Gems
// ------------------------------
//= require bootstrap
// require select2
// require refile
